import { useContext } from 'react'
import AuthorizationContext from './AuthorizationProvider.context'

/**
 * The authorization custom hook.
 */
export const useAuthorization = () => {
  const { isPublic, isPrivated, userType } = useContext(AuthorizationContext)

  return { isPublic, isPrivated, userType }
}
